import { useEffect, useState } from "react";
import ContactPhoneIcon from "@mui/icons-material/ContactPhone";
import PersonIcon from "@mui/icons-material/Person";
import BadgeIcon from "@mui/icons-material/Badge";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import VerifiedIcon from "@mui/icons-material/Verified";
import CancelIcon from "@mui/icons-material/Cancel";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import axiosInstance from "../../../Config/axiosInstance";
import "./ClientPortfolioContacts.css";

function ClientPortfolioContacts({ clientData }) {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchContacts = async () => {
      if (!clientData?.id) {
        setContacts([]);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError("");

        const response = await axiosInstance.get(
          `/client-contacts/?client=${clientData.id}`
        );

        if (Array.isArray(response.data)) {
          setContacts(response.data);
        } else if (Array.isArray(response.data?.results)) {
          setContacts(response.data.results);
        } else {
          setContacts([]);
        }
      } catch (err) {
        console.error("Eroare la încărcarea contactelor:", err);
        setError("Nu am putut încărca contactele.");
        setContacts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchContacts();
  }, [clientData?.id]);

  const getStatusClass = (status) => {
    if (!status) return "status-neutral";

    const normalized = status.toLowerCase();

    if (normalized === "active") return "status-active";
    if (normalized === "inactive") return "status-inactive";

    return "status-neutral";
  };

  if (loading) {
    return (
      <div className="contacts-state">
        <ContactPhoneIcon className="contacts-state-icon loading-spin" />
        <p>Se încarcă...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="contacts-state error-state">
        <ErrorOutlineIcon className="contacts-state-icon" />
        <p>{error}</p>
      </div>
    );
  }

  if (!contacts.length) {
    return (
      <div className="contacts-state">
        <ContactPhoneIcon className="contacts-state-icon" />
        <p>There are no contacts for this client.</p>
      </div>
    );
  }

  return (
    <div className="contacts-grid">
      {contacts.map((contact) => {
        const normalizedStatus = contact.contact_status?.toLowerCase();

        return (
          <div className="contact-card" key={contact.id}>
            <div className="contact-card-header">
              <div className="contact-avatar">
                <PersonIcon />
              </div>

              <div className="contact-main-info">
                <h4>{contact.name || "-"}</h4>
              </div>

              <span
                className={`contact-status-badge ${getStatusClass(
                  contact.contact_status
                )}`}
              >
                {normalizedStatus === "inactive" ? (
                  <CancelIcon className="status-icon" />
                ) : (
                  <VerifiedIcon className="status-icon" />
                )}

                {contact.contact_status || "Necunoscut"}
              </span>
            </div>

            <div className="contact-card-body">
              <div className="contact-info-row">
                <BadgeIcon className="contact-info-icon" />
                <div>
                  <span className="info-label">Position: </span>
                  <span className="info-value">{contact.position || "-"}</span>
                </div>
              </div>

              <div className="contact-info-row">
                <PhoneIcon className="contact-info-icon" />
                <div>
                  <span className="info-label">Phone: </span>
                  <span className="info-value">{contact.phone || "-"}</span>
                </div>
              </div>

              <div className="contact-info-row">
                <EmailIcon className="contact-info-icon" />
                <div>
                  <span className="info-label">Email: </span>
                  <span className="info-value">{contact.email || "-"}</span>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default ClientPortfolioContacts;